import React, { useEffect } from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate
} from "react-router-dom";
import { useStore } from './stores';
import { View } from '@aws-amplify/ui-react';
import SignIn from './pages/signIn';
import AdminDashboard from './pages/AdminDashboard';
import PrivateRouter from './PrivateRouter';
import { LoadingScreen } from './components';
import { observer } from 'mobx-react';
import SessionWarning from './components/SessionWarning/SessionWarning';
import NotificationSnackbar from './components/NotificationSnackbar/NotificationSnackbar'; // 👈 add this

const App = observer(() => {
  const { authStore, uiStore } = useStore();

  useEffect(() => {
    
    const handleResize = () => {
      const screenWidth = window.innerWidth;
      const screenHeight = window.innerHeight;
      uiStore.setScreenWidth(screenWidth);
      uiStore.setScreenHeight(screenHeight);
    };
    
    handleResize();
    window.addEventListener('resize', handleResize);
    
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [uiStore, authStore.isLoggedIn, authStore.isRestoringAuth]);

  // Show loading screen while restoring auth
  if (authStore.isRestoringAuth) {
    return <LoadingScreen />;
  }

  return (
    <Router>
      <View
        className="App"
        style={{ minHeight: `${window.innerHeight}px`, overflow: 'hidden' }}
      >
        <LoadingScreen />

        {/* 🔥 Mount global UI helpers */}
        <SessionWarning />
        <NotificationSnackbar /> 

        <Routes>
          <Route
            path="/login"
            element={
              authStore.isLoggedIn ? (
                <Navigate to="/AdminDashboard" replace />
              ) : (
                <SignIn />
              )
            }
          />
          <Route
            path="/AdminDashboard"
            element={
              <PrivateRouter>
                <AdminDashboard />
              </PrivateRouter>
            }
          />
          <Route
            path="*"
            element={
              authStore.isLoggedIn ? (
                <Navigate to="/AdminDashboard" replace />
              ) : (
                <Navigate to="/login" replace />
              )
            }
          />
        </Routes>
      </View>
    </Router>
  );
});

export default App;
